import { dialogAnatomy } from "@ark-ui/anatomy";
import { sva } from "@styled-system/css";

export const dialogStyles = sva({
  slots: dialogAnatomy.keys(),
  base: {
    backdrop: {
      bg: "rgba(0, 0, 0, 0.6)",
      position: "fixed",
      inset: 0,
      zIndex: 250,
      _open: { animation: "fadeIn" },
      _closed: { animation: "fadeOut" }
    },
    positioner: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "fixed",
      inset: 0,
      zIndex: 260,
      pointerEvents: "none"
    },
    content: {
      px: "2rem",
      pt: "2rem",
      pb: "1rem",
      mx: "0.5rem",
      bg: "surfaceElevated",
      w: { base: "672px", smDown: "100%" },
      position: "relative",
      borderRadius: "1.5rem",
      shadow: "0px 2px 6px 2px #00000026, 0px 1px 2px 0px #0000004D",
      zIndex: 400,
      _open: { animation: "slideIn" },
      _closed: { animation: "slideOut" },
      outline: "none"
    },
    title: {
      mb: "1rem",
      display: "flex",
      alignItems: "center",
      "& h4": {
        mb: "0rem"
      }
    },
    description: { mb: "1.5rem" },
    closeTrigger: {
      position: "absolute",
      top: "12px",
      right: "20px",
      cursor: "pointer",
      fill: "highEmphasis"
    }
  },
  variants: {
    sa: {
      infoBox: {
        content: {
          px: 0,
          pt: 0
        },
        title: {
          display: "none"
        },
        description: {
          display: "none"
        },
        closeTrigger: {
          "& svg": {
            cursor: "pointer",
            fill: "white",
            _hover: {
              fill: "rgba(255, 255, 255, 0.6)"
            }
          }
        }
      },
      newsletter: {
        content: {
          w: ["100%", "45rem"],
          overflow: "hidden",
          "& h4": {
            textAlign: "center",
            mb: "8px",
            mt: "72px",
            px: ["0px", "24px"],
            py: "0 !important",
            textStyle: "h2"
          },
          "& p": { textAlign: "center", px: ["0px", "24px"] }
        },
        closeTrigger: {
          "& svg": {
            cursor: "pointer",
            fill: "mediumEmphasis",
            _hover: {
              fill: "lowEmphasis"
            }
          }
        },
        title: {
          "& h4": {
            w: "100%"
          }
        }
      }
    }
  }
});
